# GDPR-policy för Safe Learning Management System

## 1\. Introduktion

Denna GDPR-policy beskriver hur Safe Asset Group International AB ("vi", "oss" eller "vår") följer den allmänna dataskyddsförordningen (GDPR) i förhållande till ledningssystemet Safe Learning. Denna policy bör läsas tillsammans med vår sekretesspolicy.

## 2\. Datakontrollant

Safe Asset Group International AB fungerar som personuppgiftsansvarig för personuppgifter som samlas in via Safe Learning Management System. Våra kontaktuppgifter är:

Safe Asset Group International AB  
Kivra: 559072-8746  
106 31 Stockholm  
Sverige

E-post: [info@safeassetgroup.com](mailto:info@safeassetgroup.com)  
Telefon: \+46 31 201 000

## 3\. Laglig grund för behandling

Vi behandlar personuppgifter på följande lagliga grunder:

* Samtycke: För användare som anger sitt namn och sin e-postadress för att få tillgång till tjänstens administrativa portal.  
* Berättigade intressen: För bearbetning av användningsdata för att förbättra vår tjänst.

## 4\. Rättigheter för den registrerade

Enligt GDPR har du följande rättigheter:

1. Rätt att bli informerad  
2. Rätt till tillträde  
3. Rätt till rättelse  
4. Rätt till radering ('rätt att bli glömd')  
5. Rätt att begränsa behandlingen  
6. Rätt till dataportabilitet  
7. Rätt att invända  
8. Rättigheter relaterade till automatiserat beslutsfattande inklusive profilering

För att utöva dessa rättigheter, vänligen kontakta oss med hjälp av uppgifterna i avsnitt 2\.

Obs: För användare som använder systemet via distribuerade koder, samlas ingen direkt personligt identifierbar information in. Vi samlar inte heller in tillräckligt med annan information tillräckligt detaljerad för att peka ut en specifik individ. Därför kan vi inte behandla förfrågningar om rättigheter för de registrerade för dessa användare.

## 5\. Internationella dataöverföringar

Vi lagrar all data på säkra servrar i Europeiska unionen. I händelse av att vi behöver överföra data utanför EU/EES kommer vi att se till att lämpliga skyddsåtgärder finns på plats i enlighet med GDPR-kraven.

## 6\. Datalagring

Vi behåller personuppgifter så länge det är nödvändigt för att tillhandahålla våra tjänster eller enligt lag. Specifika lagringsperioder beskrivs i vår sekretesspolicy.

## 7\. Meddelande om dataintrång

I händelse av ett personuppgiftsintrång kommer vi att meddela den relevanta tillsynsmyndigheten inom 72 timmar efter att vi blivit medvetna om intrånget, där det är möjligt. Om överträdelsen sannolikt kommer att resultera i en hög risk för dina rättigheter och friheter kommer vi också att meddela berörda personer utan onödigt dröjsmål.

## 8\. Data Protection Impact Assessment (DPIA)

Vi genomför DPIA för alla högriskdatabehandlingsaktiviteter som krävs av GDPR.

## 9\. Integritet genom design och standard

Vi implementerar lämpliga tekniska och organisatoriska åtgärder för att säkerställa att som standard endast personuppgifter som är nödvändiga för varje specifikt ändamål med behandlingen behandlas.

## 10\. Register över bearbetningsaktiviteter

Vi för register över våra bearbetningsaktiviteter i enlighet med artikel 30 i GDPR.

## 11\. Ändringar av denna GDPR-policy

Vi kan komma att uppdatera denna GDPR-policy då och då. Vi kommer att meddela dig om alla väsentliga ändringar genom att publicera den nya policyn på vår webbplats.

## 12\. Klagomål

Om du har frågor om vår databehandlingsverksamhet, vänligen kontakta oss först så att vi kan ta itu med dina problem. Du har också rätt att lämna in ett klagomål till en tillsynsmyndighet i EU-medlemsstaten där du har hemvist, arbetsplats eller plats för den påstådda överträdelsen.

Senast uppdaterad: 2024-09-05

